<template>
  <div class="cardContainer">
    <div class="containerCardCafezal ">
      <v-row class="align-center mb-5">
        <v-col cols="5">
          <h3 class="text-left pl-3">{{ index + 1 }}</h3>
        </v-col>
        <v-col cols="7">
          <h3>{{ item.seguradora.nome }}</h3>
        </v-col>
        <!-- <v-col class="text-right pr-1">
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <v-icon class="pl-1" color="secondary" size="12" v-on="on">
                fa-info-circle
              </v-icon>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Conforme previsto pela SUSEP os prazos das cotações tem
                  vigência máxima de 15 dias. Após esse período as seguradoras
                  se reservam no direito de retirar e/ou revisar as condições
                  propostas nas minutas
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </v-col> -->
      </v-row>
      <v-divider class="pb-6" />
      <v-row class="pb-2">
        <v-col class="text-left" cols="8">Área segurada</v-col>
        <v-col class="text-right" cols="4"
          >{{ asNumberString(item.area_segurada) }} ha</v-col
        >
      </v-row>
      <v-row class="pb-2">
        <v-col class="text-left" cols="8">LMI Total</v-col>
        <v-col class="text-right" cols="4"
          >R$ {{ asNumberString(getLMI) }}</v-col
        >
      </v-row>
      <v-row class="pb-3">
        <v-col class="text-left" cols="8">Indenização/ha</v-col>
        <v-col class="text-right" cols="4"
          >R$ {{ asNumberString(getRestitution) }}</v-col
        >
      </v-row>
      <v-row class="pb-2">
        <v-col class="text-left textWeight" cols="8">Coberturas:</v-col>
      </v-row>
      <v-row class="pb-2 pl-2">
        <v-col class="text-left" cols="8">
          {{ coverageBasicText }}
        </v-col>
        <v-col class="text-right" cols="4"
          >R$ {{ asNumberString(coverageBasic) }}</v-col
        >
      </v-row>
      <v-row class="pb-2 pl-2">
        <v-col class="text-left" cols="8">Perda Produção Futura</v-col>
        <v-col class="text-right" cols="4"
          >R$ {{ asNumberString(item.perda_producao_futura) }}</v-col
        >
      </v-row>
      <v-row class="pb-2 pl-2">
        <v-col class="text-left" cols="8">Tratamento Fitossanitário</v-col>
        <v-col class="text-right" cols="4"
          >R$ {{ asNumberString(item.tratamento_fitossanitario) }}</v-col
        >
      </v-row>
      <v-row class="pt-1 pb-1 row-collor-yellow">
        <v-col class="text-left" cols="4">Custo do Seguro</v-col>
        <v-col class="text-right textWeight pl-2" cols="4"
          >POS - Reduzida</v-col
        >
        <v-col class="text-right textWeight" cols="4">POS - Normal</v-col>
      </v-row>
      <v-row class="row-collor-blue pb-1 pt-1">
        <v-col class="text-left" cols="4">Prêmio Total</v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(item.pos_reduzido.premio_total)
        }}</v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(item.pos_normal.premio_total)
        }}</v-col>
      </v-row>
      <v-row class="pt-1 pb-1 row-collor-yellow">
        <v-col class="text-left" cols="4">Subvenção Federal</v-col>
        <v-col class="text-right" cols="4">
          {{ getValidEmptyText(item.pos_reduzido.subvencao_federal) }}</v-col
        >
        <v-col class="text-right" cols="4">
          {{ getValidEmptyText(item.pos_normal.subvencao_federal) }}</v-col
        >
      </v-row>
      <v-row class="pt-1 pb-1 row-collor-yellow">
        <v-col class="text-left" cols="4">Subvenção Estadual</v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(item.pos_reduzido.subvencao_estadual)
        }}</v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(item.pos_normal.subvencao_estadual)
        }}</v-col>
      </v-row>
      <v-row class="row-collor-blue pt-1 pb-1">
        <v-col class="text-left" cols="4">Prêmio Segurado</v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(item.pos_reduzido.premio_segurado)
        }}</v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(item.pos_normal.premio_segurado)
        }}</v-col>
      </v-row>
      <v-row class="pt-1 pb-1 row-collor-yellow">
        <v-col class="text-left" cols="4">Investimento R$/ha</v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(item.pos_reduzido.investimento)
        }}</v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(item.pos_normal.investimento)
        }}</v-col>
      </v-row>
      <v-row class="pt-1 pb-1 row-collor-yellow">
        <v-col class="text-left" cols="4">
          5 Parcelas de
        </v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(getParcelPosReduzido)
        }}</v-col>
        <v-col class="text-right" cols="4">{{
          getValidEmptyText(getParcelPosNormal)
        }}</v-col>
      </v-row>
      <v-row
        class="align-center justify-center pt-6 no-print"
        v-if="showButton"
      >
        <BaseButton
          v-html="'CONTRATAR'"
          class="buttonContract no-print"
          outlined
          @click="handleClick(item)"
        >
        </BaseButton>
      </v-row>
    </div>
  </div>
</template>
<script>
import { asNumberString } from "@/utils/formats.js";
import BaseButton from "../../../components/base/BaseButton.vue";
export default {
  components: { BaseButton },
  props: {
    item: Object,
    index: Number,
    showButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      asNumberString
    };
  },
  computed: {
    getParcelPosReduzido() {
      let parcela = 0;
      if (this.item.pos_reduzido.premio_segurado != null) {
        parcela = this.item.pos_reduzido.premio_segurado / 5;
      }
      return parcela;
    },
    getParcelPosNormal() {
      let parcela = 0;
      if (this.item.pos_normal.premio_segurado != null) {
        parcela = this.item.pos_normal.premio_segurado / 5;
      }
      return parcela;
    },
    getLMI() {
      return this.coverageBasic + this.item.perda_producao_futura;
    },
    getRestitution() {
      return this.getLMI / this.item.area_segurada;
    },
    coverageBasic() {
      return this.item.granizo_geada
        ? this.item.granizo_geada
        : this.item.granizo;
    },
    coverageBasicText() {
      let text;
      if (this.item.granizo_geada) {
        text = "Granizo e Geada";
      }
      if (this.item.granizo) {
        text = "Granizo";
      }
      return text;
    }
  },
  methods: {
    handleClick() {
      this.$emit("open-payment", this.item);
    },
    getValidEmptyText(item) {
      if (item == null || item == "") return "-";

      return "R$ " + asNumberString(item);
    }
  }
};
</script>
<style lang="sass">
.cardContainer
  margin-top: 30px
.containerCardCafezal
  font-size: 10px
  border: 1px solid #d5d5e0
  padding-top: 20px
  padding-bottom: 20px
  letter-spacing: 0.5px
  width: 330px !important
.text-left
  padding-left: 12px
  font-weight: 800
.text-right
  padding-right: 12px
  font-weight: 700
.row-collor-blue
  background: #6b8ae6
.row-collor-yellow
  background-color: #e3e3ee
  margin-top: 4px
  margin-bottom: 4px
.buttonContract
  color: blue
  cursor: pointer
@media print
  .no-print
    display: none
  .cardContainer
    margin-top: 10px !important
    padding: 0px !important
  .containerCardCafezal
    font-size: 8px !important
    padding-top: 10px !important
    margin: 0px !important
    width: auto !important
</style>
